/* ======================================================
   OGP Graduated Bundle — SINGLE FILE (CLEAN + NO DUP FRAME)
   File: assets/ogp-graduated.bundle.js
====================================================== */
(function () {
  "use strict";

  // ✅ HARD GUARD: se lo script viene incluso 2 volte, NON reinizializza.
  if (window.__OGP_GRADUATED_BUNDLE_LOADED__) return;
  window.__OGP_GRADUATED_BUNDLE_LOADED__ = true;

  /* =======================
     CONFIG MAP
  ======================= */
  const OGP_LENS_MAP = window.OGP_LENS_MAP || {
    "1.50": {
      label: "1.50 Basic",
      desc: "Lente standard per uso quotidiano. Buon rapporto qualità/prezzo. UV Block disponibile come trattamento.",
      base: { id: 56264478294364, priceCents: 4900, includes: ["uv"] },
      addons: {
        ar:        { id: 56239773319516, priceCents: 2000, desc: "Antiriflesso base: riduce riflessi e migliora nitidezza." },
        blue:      { id: 56239774105948, priceCents: 3000, desc: "Riduce affaticamento da schermi e luce blu." },
        totalblue: { id: 56239790457180, priceCents: 6500, desc: "Protezione avanzata: luce blu + UV, comfort digitale top." },
        drive:     { id: 56239797043548, priceCents: 8000, desc: "Ottimizzato per guida: meno aloni e riflessi notturni, migliora il contrasto." }
      }
    },
    "1.60": {
      label: "1.60 Comfort",
      desc: "Più sottile e resistente rispetto alla 1.50. Scelta equilibrata per estetica e comfort.",
      base: { id: 56264591343964, priceCents: 9900, includes: ["ar"] },
      addons: {
        blue:      { id: 56239785705820, priceCents: 1500, desc: "Riduce affaticamento da schermi e luce blu." },
        totalblue: { id: 56239790489948, priceCents: 3500, desc: "Protezione avanzata: luce blu + UV, comfort digitale top." },
        drive:     { id: 56239797076316, priceCents: 5000, desc: "Ottimizzato per guida: meno aloni e riflessi notturni, migliora il contrasto." }
      }
    },
    "1.67": {
      label: "1.67 Slim",
      desc: "Sottile e più estetica per gradazioni medio-alte. Riduce spessore e migliora il look finale.",
      base: { id: 56264591376732, priceCents: 12400, includes: ["ar"] },
      addons: {
        blue:      { id: 56239785738588, priceCents: 1500, desc: "Riduce affaticamento da schermo e assorbe la luce blu dei dispositivi digitali." },
        totalblue: { id: 56239790522716, priceCents: 3500, desc: "Protezione avanzata: luce blu + UV, comfort digitale top." },
        drive:     { id: 56239797109084, priceCents: 5000, desc: "Ottimizzato per guida: meno aloni e riflessi notturni, migliora il contrasto." }
      }
    },
    "1.74": {
      label: "1.74 Ultra Slim",
      desc: "Massima sottigliezza per gradazioni alte. Risultato più leggero e pulito esteticamente.",
      base: { id: 56264591409500, priceCents: 13900, includes: ["ar"] },
      addons: {
        blue:      { id: 56239785771356, priceCents: 1500, desc: "Riduce affaticamento da schermi e luce blu." },
        totalblue: { id: 56239790555484, priceCents: 3500, desc: "Protezione avanzata: luce blu + UV, comfort digitale top." },
        drive:     { id: 56239797141852, priceCents: 8000, desc: "Ottimizzato per guida: meno aloni e riflessi notturni, migliora il contrasto." }
      }
    }
  };

  const OGP_TREATMENTS = window.OGP_TREATMENTS || [
    { key: "uv",        label: "UV Block",           desc: "Filtro UV per protezione aggiuntiva in esterno.", availableFor: ["1.50"] },
    { key: "ar",        label: "AR Classico",        desc: "Riduce riflessi e aumenta nitidezza.",          availableFor: ["1.50"] },
    { key: "blue",      label: "Blocco Luce Blu",    desc: "Aiuta con schermi e affaticamento visivo.",    availableFor: ["1.50","1.60","1.67","1.74"] },
    { key: "totalblue", label: "Total Blue UVBlock", desc: "Luce blu + UV: protezione completa e comfort.", availableFor: ["1.50","1.60","1.67","1.74"] },
    { key: "drive",     label: "AR Drive Top",       desc: "Antiriflesso per la guida: meno aloni e riflessi da fari/luci.", availableFor: ["1.50","1.60","1.67","1.74"] }
  ];

  const OGP_SUN_PACKAGES = window.OGP_SUN_PACKAGES || {
    base: {
      label: "Base",
      priceCents: 15900,
      id: 57566297358684 ,
      desc: "Occhiale da sole graduato completo con lente colorata standard."
    },
    sottile: {
      label: "Sottile",
      priceCents: 22900,
      id: 57566345396572 ,
      desc: "Lente più sottile, più estetica e confortevole."
    },
    ultrasottile: {
      label: "Ultra Sottile",
      priceCents: 26900,
      id: 57566347395420,
      desc: "Massima sottigliezza per un risultato più leggero e premium."
    }
  };

  const OGP_SUN_COLORS = window.OGP_SUN_COLORS || [
  {
    key: "grigio",
    label: "Grigio",
    desc: "Neutro, elegante, ideale per uso quotidiano.",
    lensColor: "linear-gradient(135deg, #3f3f46, #a1a1aa)"
  },
  {
    key: "marrone",
    label: "Marrone",
    desc: "Più contrasto e visione calda, ottimo in esterno.",
    lensColor: "linear-gradient(135deg, #7c3f16, #c0843d)"
  },
  {
    key: "verde_g15",
    label: "Verde G15",
    desc: "Look classico premium. Disponibile da Sottile in su.",
    lensColor: "linear-gradient(135deg, #355e3b, #7a9b5d)"
  }
];

  const DI_LINK = "https://ogpocchiali.com/pages/calcolo-distanza-interpupillare?_pos=1&_psq=DI&_ss=e&_v=1.0";

  const qs  = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => Array.from(root.querySelectorAll(s));

  function getUrlParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }
  function safeNum(v) {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  }
  function money(cents) {
    return `€${(safeNum(cents) / 100).toFixed(2)}`;
  }
  function buildGroupId() {
    return `ogp_${Date.now()}_${Math.random().toString(16).slice(2)}`;
  }

  async function fetchJson(url) {
    const r = await fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin", cache: "no-store" });
    if (!r.ok) throw new Error(`Fetch failed: ${url}`);
    return r.json();
  }

  async function cartAddJson(items) {
    const r = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store",
      body: JSON.stringify({ items })
    });
    if (!r.ok) {
      let body = "";
      try { body = await r.text(); } catch (_) {}
      const err = new Error(body || `cart/add.js failed (${r.status})`);
      err.status = r.status;
      err.body = body;
      throw err;
    }
    return true;
  }

  async function cartChangeByKey(key, quantity, properties) {
    const payload = { id: key, quantity };
    if (properties) payload.properties = properties;

    const r = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store",
      body: JSON.stringify(payload)
    });
    if (!r.ok) throw new Error(`cart/change.js failed (${r.status})`);
    return r.json();
  }

  // ✅ FormData add (multi-file su properties)
  async function cartAddFormDataOne(item, filesOrNull, filePropBaseName) {
    const fd = new FormData();
    fd.append("id", String(item.id));
    fd.append("quantity", String(item.quantity || 1));

    const props = item.properties || {};
    Object.keys(props).forEach(k => fd.append(`properties[${k}]`, String(props[k])));

    const files = Array.isArray(filesOrNull) ? filesOrNull : (filesOrNull ? [filesOrNull] : []);
    files.forEach((f, i) => {
      if (!f) return;
      const keyName = files.length === 1 ? filePropBaseName : `${filePropBaseName} ${i + 1}`;
      fd.append(`properties[${keyName}]`, f);
    });

    const r = await fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd,
      credentials: "same-origin",
      cache: "no-store"
    });

    if (!r.ok) {
      let body = "";
      try { body = await r.text(); } catch (_) {}
      const err = new Error(body || `cart/add.js failed (${r.status})`);
      err.status = r.status;
      err.body = body;
      throw err;
    }

    return true;
  }

  /* =======================
     VARIANT PICKER (PRODUCT PAGE)
     - prende SEMPRE la variante attuale selezionata in Dawn
  ======================= */
  function getSelectedVariantIdFromPage() {
    const idInput = document.querySelector("form[action*='/cart/add'] input[name='id']");
    if (idInput && idInput.value) {
      const v = Number(idInput.value);
      if (Number.isFinite(v) && v > 0) return v;
    }

    const any = document.querySelector("input[name='id'][value]");
    if (any && any.value) {
      const v = Number(any.value);
      if (Number.isFinite(v) && v > 0) return v;
    }
    return null;
  }

  /* =======================
     PATCH LINK "AGGIUNGI LENTI"
  ======================= */
  function patchConfiguratorLinks() {
    const selector =
      "a.ogp-configurator-link[href*='/pages/configuratore-lenti'], a[href*='/pages/configuratore-lenti']";

    const applyVariantToHref = (a, vId) => {
      try {
        const href = a.getAttribute("href") || "";
        const url = new URL(href, window.location.origin);
        if (!url.searchParams.get("product")) return;

        url.searchParams.set("variant", String(vId));

        const hash = url.hash || "";
        a.setAttribute("href", url.pathname + "?" + url.searchParams.toString() + hash);
      } catch (_) {}
    };

    const refreshAll = () => {
      const vId = getSelectedVariantIdFromPage();
      if (!vId) return;
      qsa(selector).forEach(a => applyVariantToHref(a, vId));
    };

    qsa(selector).forEach(a => {
      if (a.dataset.ogpBound === "1") return;
      a.dataset.ogpBound = "1";

      a.addEventListener(
        "click",
        (e) => {
          const vId = getSelectedVariantIdFromPage();
          if (!vId) return;

          try {
            const href = a.getAttribute("href") || "";
            const url = new URL(href, window.location.origin);
            if (!url.searchParams.get("product")) return;

            url.searchParams.set("variant", String(vId));
            e.preventDefault();
            window.location.href = url.toString();
          } catch (_) {}
        },
        { passive: false }
      );
    });

    const idInput = document.querySelector("form[action*='/cart/add'] input[name='id']");
    if (!idInput) {
      refreshAll();
      return;
    }

    refreshAll();

    if (idInput.dataset.ogpObserver === "1") return;
    idInput.dataset.ogpObserver = "1";

    let last = idInput.value;

    const obs = new MutationObserver(() => {
      const now = idInput.value;
      if (!now || now === last) return;
      last = now;
      refreshAll();
    });

    obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });

    const bump = () => {
      const now = idInput.value;
      if (!now || now === last) return;
      last = now;
      refreshAll();
    };
    idInput.addEventListener("change", bump, { passive: true });
    idInput.addEventListener("input", bump, { passive: true });
  }

  /* =======================
     MODAL
  ======================= */
  function showModal(title, text, items) {
    const modal = qs("#ogp-modal");
    const tEl = qs("#ogp-modal-title");
    const pEl = qs("#ogp-modal-text");
    const listEl = qs("#ogp-modal-list");

    if (!modal || !tEl || !pEl || !listEl) {
      alert([title, text, ...(items || [])].filter(Boolean).join("\n"));
      return;
    }

    tEl.textContent = title || "Controlla i dati";
    pEl.textContent = text || "Completa i campi richiesti prima di continuare.";
    listEl.innerHTML = "";

    (items || []).forEach(x => {
      const li = document.createElement("li");
      li.textContent = x;
      listEl.appendChild(li);
    });

    modal.style.display = "block";
    modal.setAttribute("aria-hidden", "false");
  }

  function closeModal() {
    const modal = qs("#ogp-modal");
    if (!modal) return;
    modal.style.display = "none";
    modal.setAttribute("aria-hidden", "true");
  }

  function initModalListeners() {
    qsa("[data-ogp-modal-close]").forEach(el => {
      if (el.dataset.ogpBound === "1") return;
      el.dataset.ogpBound = "1";
      el.addEventListener("click", closeModal);
    });

    if (document.documentElement.dataset.ogpModalEsc !== "1") {
      document.documentElement.dataset.ogpModalEsc = "1";
      document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeModal(); });
    }
  }
    /* =======================
     CONFIGURATORE PAGE INIT
  ======================= */
  async function initConfiguratorIfPresent() {
    const indiceContainer = qs("#ogp-indice-container");
    const trattamentiContainer = qs("#ogp-trattamenti-container");
    const addToCartBtn = qs("#ogp-add-to-cart");
    if (!indiceContainer || !trattamentiContainer) return;

    if (document.documentElement.dataset.ogpConfiguratorInit === "1") return;
    document.documentElement.dataset.ogpConfiguratorInit = "1";

    initModalListeners();

    const steps = qsa(".ogp-step");
    const navItems = qsa(".ogp-step-nav-item");
    const progressBar = qs("#ogp-progress-bar");

    const frameNameEl = qs("#ogp-frame-name");
    const frameImgEl = qs("#ogp-frame-image");

    const previewIndiceEl = qs("#ogp-preview-indice");
    const previewTrattamentoEl = qs("#ogp-preview-trattamento");
    const previewTipoEl = qs("#ogp-preview-tipo");
    const previewPrezzoEl = qs("#ogp-preview-prezzo");
    const previewTotaleEl = qs("#ogp-preview-totale");

    const btnStep1Next = qs("#ogp-step1-next");
    const btnStep2Next = qs("#ogp-step2-next");
    const btnStep3Next = qs("#ogp-step3-next");
    const summaryDiv = qs("#ogp-summary");

    const fileInput = qs("#prescription_file");
    const fileInfo = qs("#prescription_file_info");

    const rxChoice = qs("#ogp-rx-choice");
    const rxManualWrap = qs("#ogp-rx-manual");
    const rxUploadWrap = qs("#ogp-rx-upload");
    const pdHelper = qs("#ogp-pd-helper");

    const config = {
      productHandle: getUrlParam("product") || null,
      frameVariantId: safeNum(getUrlParam("variant")),
      frameTitle: "",
      frameVariantTitle: "",
      frameImage: "",
      framePriceCents: 0,

      indice: null,
      treatmentKey: null,

      lensMode: "vista",
      sunColor: null,
      sunPackage: null,

      prescriptionFiles: [],
      rxMode: "upload",

      reuseFrameLineKey: null,
      reuseFrameHasGroup: false,
      reuseFrameGroupId: ""
    };

    function syncSelectionsFromDOM() {
      const idxBtn =
        document.querySelector('[data-indice][aria-pressed="true"]') ||
        document.querySelector(".ogp-choice-btn.is-active[data-indice]");

      const trtBtn =
        document.querySelector('[data-treatment][aria-pressed="true"]') ||
        document.querySelector(".ogp-card-btn.is-active[data-treatment]");

      if (idxBtn) config.indice = idxBtn.getAttribute("data-indice");
      if (trtBtn) config.treatmentKey = trtBtn.getAttribute("data-treatment");
    }

    if (fileInput) {
      fileInput.setAttribute("multiple", "multiple");
      fileInput.setAttribute("accept", "image/*,application/pdf");

      fileInput.addEventListener("change", () => {
        const files = Array.from((fileInput.files || [])).filter(Boolean);
        config.prescriptionFiles = files;

        if (fileInfo) {
          if (!files.length) fileInfo.textContent = "Nessun file caricato.";
          else if (files.length === 1) fileInfo.textContent = `File selezionato: ${files[0].name}`;
          else {
            const names = files.slice(0, 3).map(f => f.name).join(", ");
            const more = files.length > 3 ? ` +${files.length - 3} altri` : "";
            fileInfo.textContent = `File selezionati: ${names}${more}`;
          }
        }
      });
    }

    function setRxMode(mode) {
      config.rxMode = mode === "manual" ? "manual" : "upload";

      if (rxManualWrap) rxManualWrap.style.display = (config.rxMode === "manual") ? "" : "none";
      if (rxUploadWrap) rxUploadWrap.style.display = (config.rxMode === "upload") ? "" : "none";

      qsa("[data-ogp-rx-mode]", rxChoice || document).forEach(btn => {
        const m = btn.getAttribute("data-ogp-rx-mode");
        btn.classList.toggle("is-active", m === config.rxMode);
        btn.setAttribute("aria-pressed", (m === config.rxMode) ? "true" : "false");
      });
    }

    function injectRxChooserUI() {
      if (!rxChoice) return;
      if (qs("[data-ogp-rx-mode]", rxChoice)) return;

      rxChoice.innerHTML = `
        <button type="button" class="ogp-rx-card" data-ogp-rx-mode="upload" aria-pressed="false">
          <div class="ogp-rx-card-title">Carica ricetta</div>
          <p class="ogp-rx-card-desc">Carica una o più foto/PDF della prescrizione.</p>
        </button>

        <button type="button" class="ogp-rx-card" data-ogp-rx-mode="manual" aria-pressed="false">
          <div class="ogp-rx-card-title">Inserisci correzione</div>
          <p class="ogp-rx-card-desc">Inserisci i valori manualmente.</p>
        </button>
      `;

      rxChoice.addEventListener("click", (ev) => {
        const btn = ev.target.closest("[data-ogp-rx-mode]");
        if (!btn) return;
        setRxMode(btn.getAttribute("data-ogp-rx-mode"));
      });

      setRxMode("upload");
    }

    function injectPdHelperLink() {
      if (!pdHelper) return;
      if (pdHelper.dataset.ogpReady === "1") return;
      pdHelper.dataset.ogpReady = "1";

      pdHelper.innerHTML = `
        <div class="ogp-step-mini" style="color:#64748b; font-size:13px; line-height:1.35;">
          Non la conosci? Usa il nostro Misuratore DI:
          <a href="${DI_LINK}" target="_blank" rel="noopener">Apri misuratore</a>
        </div>
      `;
    }

    function showStep(step) {
      steps.forEach(s => {
        const n = Number(s.getAttribute("data-step"));
        s.style.display = (n === step) ? "" : "none";
      });

      navItems.forEach(n => {
        const s = Number(n.getAttribute("data-step"));
        n.classList.toggle("active", s === step);
      });

      if (progressBar) {
        const pct = Math.round(((step - 1) / 3) * 100);
        progressBar.style.width = `${pct}%`;
      }

      if (step === 2) injectRxChooserUI();
      if (step === 3) injectPdHelperLink();
      if (step === 4) renderSummary();
    }

    qsa(".ogp-back").forEach(b => {
      if (b.dataset.ogpBound === "1") return;
      b.dataset.ogpBound = "1";

      b.addEventListener("click", () => {
        const prev = Number(b.getAttribute("data-prev"));
        if (prev) showStep(prev);
      });
    });

    async function loadFrame() {
      if (!config.productHandle) {
        if (frameNameEl) frameNameEl.textContent = "Nessuna montatura selezionata";
        return;
      }

      const prod = await fetchJson(`/products/${config.productHandle}.js`);
      const variants = Array.isArray(prod.variants) ? prod.variants : [];

      if (!config.frameVariantId && variants.length) {
        config.frameVariantId = variants[0].id;
      }

      const chosen = variants.find(v => v.id === config.frameVariantId) || variants[0];

      config.frameTitle = prod.title || config.productHandle;
      config.frameVariantTitle = chosen ? chosen.title : "";
      config.framePriceCents = chosen ? safeNum(chosen.price) : safeNum(prod.price);

      const vImg = chosen && chosen.featured_image ? chosen.featured_image.src : null;
      config.frameImage = vImg || prod.featured_image || "";

      if (frameNameEl) {
        config.frameVariantTitle
          ? (frameNameEl.textContent = `${config.frameTitle} (${config.frameVariantTitle})`)
          : (frameNameEl.textContent = config.frameTitle);
      }

      if (frameImgEl && config.frameImage) {
        frameImgEl.src = config.frameImage;
      }
    }

    function calcLensCents() {
      if (!config.indice) return { base: 0, addon: 0, total: 0 };

      const map = OGP_LENS_MAP[config.indice];
      if (!map) return { base: 0, addon: 0, total: 0 };

      const base = safeNum(map.base.priceCents);

      let addon = 0;

      const key = config.treatmentKey;

      if (key && key !== "uv") {
        const included = Array.isArray(map.base.includes) ? map.base.includes : [];

        if (!included.includes(key)) {
          const a = map.addons && map.addons[key];
          addon = a ? safeNum(a.priceCents) : 0;
        }
      }

      return { base, addon, total: base + addon };
    }

    function calcTotalCents() {
      const frame = safeNum(config.framePriceCents);

      if (config.lensMode === "sole") {
        const pack = OGP_SUN_PACKAGES[config.sunPackage || ""];
        const sun = pack ? safeNum(pack.priceCents) : 0;

        return {
          frame: 0,
          lens: sun,
          total: sun,
          lensBreak: {
            base: sun,
            addon: 0,
            total: sun
          }
        };
      }

      const lens = calcLensCents();

      return {
        frame,
        lens: lens.total,
        total: frame + lens.total,
        lensBreak: lens
      };
    }

    function setPreview() {

      if (config.lensMode === "sole") {

        const color = OGP_SUN_COLORS.find(x => x.key === config.sunColor);
        const pack = OGP_SUN_PACKAGES[config.sunPackage || ""];

        if (previewIndiceEl) {
          previewIndiceEl.textContent = "Sole graduato";
        }

        if (previewTrattamentoEl) {
          previewTrattamentoEl.textContent = color ? color.label : "—";
        }

        if (previewTipoEl) {
          previewTipoEl.textContent = pack ? pack.label : "—";
        }

        const tot = calcTotalCents();

        if (previewPrezzoEl) {
          previewPrezzoEl.textContent =
            pack ? `Prezzo fisso completo: ${money(pack.priceCents)}` : "—";
        }

        if (previewTotaleEl) {
          previewTotaleEl.textContent = `Totale: ${money(tot.total)}`;
        }

        if (btnStep1Next) {
          btnStep1Next.disabled = !(config.sunColor && config.sunPackage);
        }

        return;
      }

      if (previewIndiceEl) previewIndiceEl.textContent = config.indice || "—";

      const t = OGP_TREATMENTS.find(x => x.key === config.treatmentKey);

      if (previewTrattamentoEl) {
        previewTrattamentoEl.textContent = t ? t.label : "—";
      }

      const map = OGP_LENS_MAP[config.indice || ""];

      if (previewTipoEl) {
        previewTipoEl.textContent = map ? map.label : "—";
      }

      const tot = calcTotalCents();

      if (previewPrezzoEl) {
        previewPrezzoEl.textContent =
          `Montatura: ${money(tot.frame)} — Lenti: ${money(tot.lensBreak.total)}`;
      }

      if (previewTotaleEl) {
        previewTotaleEl.textContent = `Totale: ${money(tot.total)}`;
      }

      if (btnStep1Next) {
        btnStep1Next.disabled = !(config.indice && config.treatmentKey);
      }
    }
        function injectLensModeUI() {
      const step1 = qs('.ogp-step[data-step="1"]');
      if (!step1) return;
      if (qs("#ogp-lens-mode-container")) return;
      if (!qs("#ogp-sun-ui-style")) {
  const style = document.createElement("style");
  style.id = "ogp-sun-ui-style";
  style.textContent = `
    .ogp-grid-mode{grid-template-columns:1fr 1fr!important;gap:14px!important;margin-bottom:18px!important;}
    @media(max-width:740px){.ogp-grid-mode{grid-template-columns:1fr!important;}}

    .ogp-mode-card{min-height:132px;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;position:relative;gap:8px;}
    .ogp-mode-icon{font-size:34px;line-height:1;margin-bottom:2px;}

    .ogp-mode-card.is-active::after,
    .ogp-sun-color-card.is-active::after,
    .ogp-sun-package-card.is-active::after{
      content:"✓";position:absolute;top:12px;right:12px;width:24px;height:24px;border-radius:999px;
      background:#ff66ff;color:#fff;display:grid;place-items:center;font-size:14px;font-weight:900;
      box-shadow:0 6px 14px rgba(255,102,255,.35);
    }

    .ogp-sun-color-grid{display:grid!important;grid-template-columns:1fr!important;gap:14px!important;width:100%!important;}
@media(min-width:1200px){.ogp-sun-color-grid{grid-template-columns:repeat(3,1fr)!important;}}
    @media(max-width:740px){.ogp-sun-color-grid{grid-template-columns:1fr!important;}}

    .ogp-sun-color-card{min-height:210px;width:100%!important;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;text-align:center;position:relative;padding:18px 16px!important;}
    .ogp-lens-dot{width:74px;height:74px;border-radius:999px;display:block;margin:0 auto 14px;box-shadow:inset -10px -12px 18px rgba(0,0,0,.18),inset 8px 8px 14px rgba(255,255,255,.22),0 10px 18px rgba(15,23,42,.12);position:relative;}
    .ogp-lens-dot::after{content:"";position:absolute;width:20px;height:9px;border-radius:999px;background:rgba(255,255,255,.55);top:15px;right:14px;transform:rotate(35deg);}
    .ogp-sun-color-title{font-weight:900;color:#0f172a;margin-bottom:6px;}
    .ogp-sun-color-desc{color:#64748b;font-size:13px;line-height:1.35;max-width:100%;margin:0 auto;}

    .ogp-sun-package-card{position:relative;display:grid;grid-template-columns:42px 1fr auto;align-items:center;gap:12px;padding:14px!important;}
    .ogp-package-icon{width:36px;height:36px;border-radius:12px;display:grid;place-items:center;font-size:22px;background:rgba(0,188,173,.10);}
    .ogp-sun-package-card[data-sun-package="base"] .ogp-package-icon{background:rgba(255,102,255,.12);color:#d946ef;}
    .ogp-sun-package-card[data-sun-package="sottile"] .ogp-package-icon{background:rgba(0,188,173,.12);color:#00bcad;}
    .ogp-sun-package-card[data-sun-package="ultrasottile"] .ogp-package-icon{background:rgba(124,58,237,.12);color:#7c3aed;}
    .ogp-sun-package-title{font-weight:900;color:#0f172a;margin-bottom:3px;}
    .ogp-sun-package-desc{color:#64748b;font-size:13px;line-height:1.35;}
    .ogp-sun-package-price{font-weight:900;color:#334155;white-space:nowrap;}

    .ogp-sun-note{display:flex;gap:10px;align-items:flex-start;margin-top:14px;padding:12px 14px;border-radius:14px;background:#f8fafc;border:1px solid #e2e8f0;color:#64748b;font-size:13px;line-height:1.35;}
    .ogp-sun-note-icon{width:22px;height:22px;min-width:22px;border-radius:999px;display:grid;place-items:center;border:1px solid #0ea5e9;color:#0284c7;font-weight:900;}
  `;
  document.head.appendChild(style);
}

      const h2 = qs("h2", step1);

      const box = document.createElement("div");
      box.id = "ogp-lens-mode-injected";
      box.innerHTML = `
        <h3 class="ogp-step-subtitle">Tipologia</h3>

        <div id="ogp-lens-mode-container" class="ogp-grid ogp-grid-mode" style="grid-template-columns:1fr 1fr;margin-bottom:14px;">
          <button type="button" class="ogp-card-btn ogp-mode-card is-active" data-lens-mode="vista" aria-pressed="true">
  <div class="ogp-mode-icon">👓</div>
  <strong>Occhiali da vista</strong>
  <div class="ogp-card-desc">
    Configuratore normale con indice e trattamento.
  </div>
</button>

<button type="button" class="ogp-card-btn ogp-mode-card" data-lens-mode="sole" aria-pressed="false">
  <div class="ogp-mode-icon">🕶️</div>
  <strong>Occhiali da sole graduati</strong>
  <div class="ogp-card-desc">
    Prezzo fisso completo da 159 €, con lenti colorate graduate.
  </div>
</button>
        </div>

        <div id="ogp-sole-options" style="display:none;">
          <h3 class="ogp-step-subtitle">Colore lente sole</h3>
          <div id="ogp-sun-color-container" class="ogp-grid ogp-grid-indici"></div>

          <h3 class="ogp-step-subtitle">Pacchetto lente</h3>
          <div id="ogp-sun-package-container" class="ogp-grid ogp-grid-trattamenti"></div>

          <p class="ogp-note" style="margin-top:10px;color:#64748b;font-size:13px;">
            Il Verde G15 parte dal pacchetto Sottile: il pacchetto Base non è disponibile per questa colorazione.
          </p>
        </div>
      `;

      if (h2) {
        h2.textContent = "1. Scegli il tipo di occhiale";
        h2.insertAdjacentElement("afterend", box);
      } else {
        step1.prepend(box);
      }

      const modeWrap = qs("#ogp-lens-mode-container");
      if (modeWrap) {
        modeWrap.addEventListener("click", (ev) => {
          const btn = ev.target.closest("[data-lens-mode]");
          if (!btn) return;
          setLensMode(btn.getAttribute("data-lens-mode"));
        });
      }
    }

    function setLensMode(mode) {
      config.lensMode = mode === "sole" ? "sole" : "vista";

      const indiceTitle = qs("#ogp-indice-container")?.previousElementSibling;
      const trattTitle = qs("#ogp-trattamenti-container")?.previousElementSibling;

      if (indiceContainer) {
        indiceContainer.style.display = config.lensMode === "vista" ? "" : "none";
      }

      if (trattamentiContainer) {
        trattamentiContainer.style.display = config.lensMode === "vista" ? "" : "none";
      }

      if (indiceTitle) {
        indiceTitle.style.display = config.lensMode === "vista" ? "" : "none";
      }

      if (trattTitle) {
        trattTitle.style.display = config.lensMode === "vista" ? "" : "none";
      }

      const soleWrap = qs("#ogp-sole-options");
      if (soleWrap) {
        soleWrap.style.display = config.lensMode === "sole" ? "" : "none";
      }

      qsa("[data-lens-mode]").forEach(btn => {
        const on = btn.getAttribute("data-lens-mode") === config.lensMode;
        btn.classList.toggle("is-active", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });

      if (config.lensMode === "sole") {
        if (!config.sunColor) config.sunColor = "grigio";
        if (!config.sunPackage) config.sunPackage = "base";

        config.indice = null;
        config.treatmentKey = null;

        renderSunColors();
        renderSunPackages();
      }

      setPreview();
    }
function renderSunColors() {
  const wrap = qs("#ogp-sun-color-container");
  if (!wrap) return;

  wrap.innerHTML = OGP_SUN_COLORS.map(c => {
    const on = config.sunColor === c.key;

    return `
      <button type="button" class="ogp-card-btn ogp-sun-color-card ${on ? "is-active" : ""}" data-sun-color="${c.key}" aria-pressed="${on ? "true" : "false"}">
        <span class="ogp-lens-dot" style="background:${c.lensColor};"></span>
        <div class="ogp-sun-color-title">${c.label}</div>
        <p class="ogp-sun-color-desc">${c.desc}</p>
      </button>
    `;
  }).join("");

  wrap.onclick = (ev) => {
    const btn = ev.target.closest("[data-sun-color]");
    if (!btn) return;

    config.sunColor = btn.getAttribute("data-sun-color");

    if (config.sunColor === "verde_g15" && config.sunPackage === "base") {
      config.sunPackage = "sottile";
    }

    renderSunColors();
    renderSunPackages();
    setPreview();
  };
}
function renderSunPackages() {
  const wrap = qs("#ogp-sun-package-container");
  if (!wrap) return;

  const keys = ["base", "sottile", "ultrasottile"].filter(k => {
    if (config.sunColor === "verde_g15" && k === "base") return false;
    return true;
  });

  const icons = {
    base: "◇",
    sottile: "♧",
    ultrasottile: "◆"
  };

  wrap.innerHTML = keys.map(k => {
    const p = OGP_SUN_PACKAGES[k];
    const on = config.sunPackage === k;

    return `
      <button type="button" class="ogp-card-btn ogp-sun-package-card ${on ? "is-active" : ""}" data-sun-package="${k}" aria-pressed="${on ? "true" : "false"}">
        <span class="ogp-package-icon">${icons[k] || "◆"}</span>

        <span>
          <div class="ogp-sun-package-title">${p.label}</div>
          <div class="ogp-sun-package-desc">${p.desc}</div>
        </span>

        <span class="ogp-sun-package-price">${money(p.priceCents)}</span>
      </button>
    `;
  }).join("");

  wrap.onclick = (ev) => {
    const btn = ev.target.closest("[data-sun-package]");
    if (!btn) return;

    config.sunPackage = btn.getAttribute("data-sun-package");

    renderSunPackages();
    setPreview();
  };
}
    function renderIndici() {
      const indici = Object.keys(OGP_LENS_MAP);

      indiceContainer.innerHTML = indici.map(idx => {
        const isOn = (config.indice === idx);
        return `<button type="button" class="ogp-choice-btn ${isOn ? "is-active" : ""}" data-indice="${idx}" aria-pressed="${isOn ? "true" : "false"}">${idx}</button>`;
      }).join("");

      indiceContainer.onclick = (ev) => {
        const btn = ev.target.closest("[data-indice]");
        if (!btn) return;

        config.indice = btn.getAttribute("data-indice");
        config.treatmentKey = null;

        qsa("[data-indice]", indiceContainer).forEach(b => {
          const on = (b === btn);
          b.classList.toggle("is-active", on);
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });

        renderTrattamenti();
        setPreview();
      };
    }

    function renderTrattamenti() {
      if (!config.indice) {
        trattamentiContainer.innerHTML = `<p class="ogp-step-mini">Seleziona prima un indice.</p>`;
        return;
      }

      const idx = config.indice;
      const map = OGP_LENS_MAP[idx];
      const included = Array.isArray(map.base.includes) ? map.base.includes : [];
      const avail = OGP_TREATMENTS.filter(t => (t.availableFor || []).includes(idx));

      trattamentiContainer.innerHTML = avail.map(t => {
        const isOn = (config.treatmentKey === t.key);
        const isInc = included.includes(t.key);
        const addon = map.addons && map.addons[t.key];
        const delta = isInc ? "Incluso" : (addon ? `+${money(addon.priceCents)}` : "");

        return `
          <button type="button" class="ogp-card-btn ${isOn ? "is-active" : ""}" data-treatment="${t.key}" aria-pressed="${isOn ? "true" : "false"}">
            <div style="display:flex;justify-content:space-between;gap:12px;align-items:baseline;">
              <strong>${t.label}</strong>
              <span class="ogp-card-price">${delta}</span>
            </div>
            ${t.desc ? `<div class="ogp-card-desc" style="margin-top:6px;color:#64748b;font-size:13px;line-height:1.35;">${t.desc}</div>` : ""}
          </button>
        `;
      }).join("");

      trattamentiContainer.onclick = (ev) => {
        const btn = ev.target.closest("[data-treatment]");
        if (!btn) return;

        config.treatmentKey = btn.getAttribute("data-treatment");

        qsa("[data-treatment]", trattamentiContainer).forEach(b => {
          const on = (b === btn);
          b.classList.toggle("is-active", on);
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });

        setPreview();
      };
    }

    function getRxAndPdProps() {
      const v = (id) => (qs(id) ? String(qs(id).value || "").trim() : "");

      return {
        _ogp_od_sph: v("#od_sph"),
        _ogp_od_cyl: v("#od_cyl"),
        _ogp_od_axis: v("#od_axis"),
        _ogp_os_sph: v("#os_sph"),
        _ogp_os_cyl: v("#os_cyl"),
        _ogp_os_axis: v("#os_axis"),
        _ogp_pd_dx: v("#pd_dx"),
        _ogp_pd_sx: v("#pd_sx")
      };
    }

    function validateStep2() {
      const hasFiles = (config.prescriptionFiles || []).length > 0;

      if (config.rxMode === "upload") {
        if (hasFiles) return { ok: true, missing: [] };

        return {
          ok: false,
          missing: ["Carica almeno una foto/PDF della ricetta oppure passa a “Inserisci correzione”."]
        };
      }

      const od_sph = (qs("#od_sph")?.value || "").trim();
      const os_sph = (qs("#os_sph")?.value || "").trim();

      const missing = [];

      if (!od_sph) missing.push("Inserisci SPH Occhio Destro (OD).");
      if (!os_sph) missing.push("Inserisci SPH Occhio Sinistro (OS).");

      return { ok: missing.length === 0, missing };
    }

    function validateStep3() {
      const pd_dx = (qs("#pd_dx")?.value || "").trim();
      const pd_sx = (qs("#pd_sx")?.value || "").trim();

      const missing = [];

      if (!pd_dx) missing.push("Inserisci PD Destro (DX).");
      if (!pd_sx) missing.push("Inserisci PD Sinistro (SX).");

      return { ok: missing.length === 0, missing };
    }

    function renderSummary() {
      if (!summaryDiv) return;

      const tot = calcTotalCents();
      const rx = getRxAndPdProps();
      const files = (config.prescriptionFiles || []);
      const filesText = files.length ? files.map(f => f.name).join(", ") : "Non caricata";

      if (config.lensMode === "sole") {
        const color = OGP_SUN_COLORS.find(x => x.key === config.sunColor);
        const pack = OGP_SUN_PACKAGES[config.sunPackage || ""];

        summaryDiv.innerHTML = `
          <div class="ogp-summary-block">
            <h3>Montatura scelta</h3>
            <p>${config.frameTitle || "—"} ${config.frameVariantTitle ? `(${config.frameVariantTitle})` : ""}</p>
          </div>

          <div class="ogp-summary-block">
            <h3>Sole graduato</h3>
            <p><strong>Colore lente:</strong> ${color ? color.label : "—"}</p>
            <p><strong>Pacchetto:</strong> ${pack ? pack.label : "—"}</p>
            <p><strong>Prezzo fisso completo:</strong> ${pack ? money(pack.priceCents) : "—"}</p>
          </div>

          <div class="ogp-summary-block">
            <h3>Prescrizione</h3>
            <p><strong>OD:</strong> SPH ${rx._ogp_od_sph || "—"} | CYL ${rx._ogp_od_cyl || "—"} | AX ${rx._ogp_od_axis || "—"}</p>
            <p><strong>OS:</strong> SPH ${rx._ogp_os_sph || "—"} | CYL ${rx._ogp_os_cyl || "—"} | AX ${rx._ogp_os_axis || "—"}</p>
            <p><strong>PD:</strong> DX ${rx._ogp_pd_dx || "—"} | SX ${rx._ogp_pd_sx || "—"}</p>
            <p><strong>Ricetta:</strong> ${filesText}</p>
          </div>

          <div class="ogp-summary-block">
            <h3>Totale</h3>
            <p><strong>Totale:</strong> ${money(tot.total)}</p>
          </div>
        `;
        return;
      }

      const t = OGP_TREATMENTS.find(x => x.key === config.treatmentKey);

      summaryDiv.innerHTML = `
        <div class="ogp-summary-block">
          <h3>Montatura</h3>
          <p>${config.frameTitle || "—"} ${config.frameVariantTitle ? `(${config.frameVariantTitle})` : ""}</p>
        </div>

        <div class="ogp-summary-block">
          <h3>Lenti</h3>
          <p><strong>Indice:</strong> ${config.indice || "—"}</p>
          <p><strong>Trattamento:</strong> ${(t && t.label) || "—"}</p>
          <p><strong>Tipo:</strong> ${(OGP_LENS_MAP[config.indice || ""] && OGP_LENS_MAP[config.indice || ""].label) || "—"}</p>
        </div>

        <div class="ogp-summary-block">
          <h3>Prescrizione</h3>
          <p><strong>OD:</strong> SPH ${rx._ogp_od_sph || "—"} | CYL ${rx._ogp_od_cyl || "—"} | AX ${rx._ogp_od_axis || "—"}</p>
          <p><strong>OS:</strong> SPH ${rx._ogp_os_sph || "—"} | CYL ${rx._ogp_os_cyl || "—"} | AX ${rx._ogp_os_axis || "—"}</p>
          <p><strong>PD:</strong> DX ${rx._ogp_pd_dx || "—"} | SX ${rx._ogp_pd_sx || "—"}</p>
          <p><strong>Ricetta:</strong> ${filesText}</p>
        </div>

        <div class="ogp-summary-block">
          <h3>Totale (anteprima)</h3>
          <p>Montatura: ${money(tot.frame)}</p>
          <p>Lenti: ${money(tot.lensBreak.total)} (Base ${money(tot.lensBreak.base)} + Add-on ${money(tot.lensBreak.addon)})</p>
          <p><strong>Totale:</strong> ${money(tot.total)}</p>
        </div>
      `;
    }

    function buildSharedProps(groupId) {
  const map = OGP_LENS_MAP[config.indice];
  const t = OGP_TREATMENTS.find(x => x.key === config.treatmentKey);

  const treatmentLabel = t ? t.label : (config.treatmentKey || "");
  const lensTipo = map ? (map.label || "") : "";
  const rxProps = getRxAndPdProps();

  return {
    _ogp_group: groupId,
    _ogp_indice: config.lensMode === "sole" ? "Sole graduato" : (config.indice || ""),
    _ogp_trattamento: config.lensMode === "sole" ? "Lente colorata graduata" : (treatmentLabel || ""),
    _ogp_tipo: config.lensMode === "sole" ? "Prezzo fisso completo" : (lensTipo || ""),
    _ogp_rx_mode: config.rxMode || "",
    "Foto montatura": config.frameImage,
    _ogp_frame_image: config.frameImage,
    ...rxProps
  };
}

    function buildLensItemsOnly(groupId) {
      if (config.lensMode === "sole") {
        const pack = OGP_SUN_PACKAGES[config.sunPackage || ""];
        const color = OGP_SUN_COLORS.find(x => x.key === config.sunColor);

        if (!pack || !pack.id) return [];

        const sharedProps = {
          ...buildSharedProps(groupId),
          _ogp_role: "sun-graduated",
          _ogp_lens_part: "sole-graduato",
          _ogp_lens_mode: "sole",
          "Colore lente": color ? color.label : config.sunColor,
"Pacchetto lente": pack.label,
"Prezzo fisso": money(pack.priceCents),
"Montatura scelta": `${config.frameTitle || ""} ${config.frameVariantTitle ? "(" + config.frameVariantTitle + ")" : ""}`.trim(),


_ogp_sun_color: color ? color.label : config.sunColor,
_ogp_sun_package: pack.label,
_ogp_prezzo_fisso: money(pack.priceCents),
_ogp_montatura_scelta: `${config.frameTitle || ""} ${config.frameVariantTitle ? "(" + config.frameVariantTitle + ")" : ""}`.trim(),
_ogp_montatura_variant_id: String(config.frameVariantId || "")
        };

        return [
          {
            id: Number(pack.id),
            quantity: 1,
            properties: sharedProps
          }
        ];
      }

      const map = OGP_LENS_MAP[config.indice];
      if (!map || !map.base || !map.base.id) return [];

      const included = Array.isArray(map.base.includes) ? map.base.includes : [];
      const sharedProps = buildSharedProps(groupId);

      const items = [
        {
          id: Number(map.base.id),
          quantity: 1,
          properties: {
            ...sharedProps,
            _ogp_role: "lens-base",
            _ogp_lens_part: "base"
          }
        }
      ];

      const key = config.treatmentKey;

      if (key && key !== "uv" && !included.includes(key)) {
        const addon = map.addons && map.addons[key];

        if (addon && addon.id) {
          items.push({
            id: Number(addon.id),
            quantity: 1,
            properties: {
              ...sharedProps,
              _ogp_role: "lens-addon",
              _ogp_lens_part: "addon"
            }
          });
        }
      }

      return items;
    }

    async function detectExistingFrameInCart() {
      if (!config.frameVariantId) return;

      const cart = await fetchJson("/cart.js");
      const items = cart.items || [];

      const found = [...items].reverse().find(it => Number(it.variant_id) === Number(config.frameVariantId));
      if (!found) return;

      config.reuseFrameLineKey = found.key || null;

      const g = found.properties && found.properties._ogp_group;

      if (g) {
        config.reuseFrameHasGroup = true;
        config.reuseFrameGroupId = String(g);
      }
    }

    async function addToCartFlow() {
      syncSelectionsFromDOM();

      if (config.lensMode === "sole") {
        if (!config.sunColor || !config.sunPackage) {
          showModal("Selezione mancante", "Scegli colore e pacchetto per il sole graduato.", ["Colore lente", "Pacchetto lente"]);
          return;
        }
      } else {
        if (!config.indice || !config.treatmentKey) {
          showModal("Selezione mancante", "Scegli indice e trattamento.", ["Indice", "Trattamento"]);
          return;
        }
      }

      if (!config.productHandle || !config.frameVariantId) {
        showModal("Montatura non valida", "Torna alla montatura e riprova.", ["Variant ID mancante"]);
        return;
      }

      if (config.lensMode !== "sole") {
        await detectExistingFrameInCart();
      }

      let groupId = "";

      if (config.reuseFrameHasGroup && config.reuseFrameGroupId) {
        groupId = config.reuseFrameGroupId;
      } else {
        groupId = buildGroupId();
      }

      const sharedProps = buildSharedProps(groupId);

      if (config.lensMode !== "sole" && config.reuseFrameLineKey && !config.reuseFrameHasGroup) {
        await cartChangeByKey(config.reuseFrameLineKey, 1, {
          ...sharedProps,
          _ogp_role: "frame"
        });
      }

      const lensItems = buildLensItemsOnly(groupId);

      const bad = lensItems.find(it => !it.id || !Number.isFinite(Number(it.id)));

      if (bad) {
        showModal("Errore tecnico", "ID lente non valido.", [JSON.stringify(bad)]);
        return;
      }

      const mustAddFrame = config.lensMode === "sole" ? false : !config.reuseFrameLineKey;
      const files = Array.isArray(config.prescriptionFiles) ? config.prescriptionFiles : [];

      if (config.lensMode === "sole") {
        if (files.length) {
          await cartAddFormDataOne(lensItems[0], files, "Ricetta (PDF/FOTO)");
        } else {
          await cartAddJson(lensItems);
        }

        window.location.href = "/cart";
        return;
      }

      if (mustAddFrame) {
        const frameItem = {
          id: Number(config.frameVariantId),
          quantity: 1,
          properties: {
            ...sharedProps,
            _ogp_role: "frame"
          }
        };

        if (files.length) {
          await cartAddFormDataOne(frameItem, files, "Ricetta (PDF/FOTO)");
          await cartAddJson(lensItems);
        } else {
          await cartAddJson([frameItem, ...lensItems]);
        }
      } else {
        await cartAddJson(lensItems);
      }

      window.location.href = "/cart";
    }

    if (btnStep1Next) {
      if (btnStep1Next.dataset.ogpBound !== "1") {
        btnStep1Next.dataset.ogpBound = "1";

        btnStep1Next.addEventListener("click", () => {
          syncSelectionsFromDOM();

          if (config.lensMode === "sole") {
            if (!config.sunColor || !config.sunPackage) {
              showModal("Selezione mancante", "Scegli colore e pacchetto per il sole graduato.", ["Colore lente", "Pacchetto lente"]);
              return;
            }

            showStep(2);
            return;
          }

          if (!config.indice || !config.treatmentKey) {
            showModal("Selezione mancante", "Scegli indice e trattamento per continuare.", ["Indice", "Trattamento"]);
            return;
          }

          showStep(2);
        });
      }
    }

    if (btnStep2Next) {
      if (btnStep2Next.dataset.ogpBound !== "1") {
        btnStep2Next.dataset.ogpBound = "1";

        btnStep2Next.addEventListener("click", () => {
          const v = validateStep2();

          if (!v.ok) {
            showModal("Mancano alcuni dati", "Completa i dati richiesti per continuare.", v.missing);
            return;
          }

          showStep(3);
        });
      }
    }

    if (btnStep3Next) {
      if (btnStep3Next.dataset.ogpBound !== "1") {
        btnStep3Next.dataset.ogpBound = "1";

        btnStep3Next.addEventListener("click", () => {
          const v = validateStep3();

          if (!v.ok) {
            showModal("PD mancante", "Inserisci la distanza interpupillare per continuare.", v.missing);
            return;
          }

          showStep(4);
        });
      }
    }

    if (addToCartBtn) {
      if (addToCartBtn.dataset.ogpBound !== "1") {
        addToCartBtn.dataset.ogpBound = "1";

        addToCartBtn.addEventListener("click", async (e) => {
          e.preventDefault();
          e.stopPropagation();

          addToCartBtn.disabled = true;
          addToCartBtn.setAttribute("aria-busy", "true");

          try {
            await addToCartFlow();
          } catch (err) {
            console.error("OGP addToCart error:", err);

            showModal("Errore aggiunta al carrello", "Si è verificato un errore tecnico.", [
              String(err.message || err)
            ]);

            addToCartBtn.disabled = false;
            addToCartBtn.removeAttribute("aria-busy");
          }
        }, { passive: false });
      }
    }

    await loadFrame();
    injectLensModeUI();
    renderIndici();
    renderTrattamenti();
    renderSunColors();
    renderSunPackages();
    setLensMode("vista");
    setPreview();
    showStep(1);
  }

  /* =======================
     BOOTSTRAP (SINGLE RUN)
  ======================= */
  function boot() {
    patchConfiguratorLinks();
    initConfiguratorIfPresent().catch(err => console.error("OGP init error:", err));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

})();